import * as React from 'react';
import classes from './Group.module.css';
import { Task } from '../../types';
import TaskListItem from '../TaskList/TaskListItem';

type OrganizationGroupProps = {
  height: number;
  tasks: Task[];
}

const OrganizationGroup = ({
  height,
  tasks,
}: OrganizationGroupProps) => {
  return (
    <div
      className={`transition-height px-6 py-8 ${classes['group']}`}
      style={{ height }}
    >
      {tasks.length === 0 && (
        <div className="w-full h-full flex items-center justify-center">
          <h3 className="text-xl font-thin uppercase">Ingen sager der skal placeres</h3>
        </div>
      )}
      {tasks.length > 0 && (
        <div className="grid grid-cols-4 gap-4">
          {tasks.map((task) => (
            <TaskListItem
              key={task.id}
              task={task}
              isExpanded={true}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default OrganizationGroup;
